var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryFrontEndWebMobile16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Mobile_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Front-End-Web-Mobile_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Mobile_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Front-End-Web-Mobile_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-18",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Mobile_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,14 L13,14 L13,13 L11,13 L11,14 Z M15,14.5 L15,12 L9,12 L9,14.5 C9,14.776 9.225,15 9.5,15 L14.5,15 C14.775,15 15,14.776 15,14.5 L15,14.5 Z M9,11 L15,11 L15,5.5 C15,5.224 14.775,5 14.5,5 L9.5,5 C9.225,5 9,5.224 9,5.5 L9,11 Z M16,5.5 L16,14.5 C16,15.327 15.327,16 14.5,16 L9.5,16 C8.673,16 8,15.327 8,14.5 L8,5.5 C8,4.673 8.673,4 9.5,4 L14.5,4 C15.327,4 16,4.673 16,5.5 L16,5.5 Z M3,3 L9,3 L9,2 L2.5,2 C2.224,2 2,2.224 2,2.5 L2,11.5 C2,11.776 2.224,12 2.5,12 L7,12 L7,11 L3,11 L3,3 Z M1.241,13 L7,13 L7,14 L1.241,14 C0.557,14 0,13.443 0,12.759 L0,1.259 C0,0.564 0.564,0 1.259,0 L9.741,0 C10.436,0 11,0.564 11,1.259 L11,3 L10,3 L10,1.259 C10,1.119 9.882,1 9.741,1 L1.259,1 C1.118,1 1,1.119 1,1.259 L1,12.759 C1,12.892 1.108,13 1.241,13 L1.241,13 Z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryFrontEndWebMobile16);
export default __webpack_public_path__ + "static/media/Arch-Category_Front-End-Web-Mobile_16.8fc363cfa618d010accb440396a9ea9d.svg";
export { ForwardRef as ReactComponent };